export default __webpack_public_path__ + "static/media/like.f5250988.svg";